import { Box, Backdrop, CircularProgress, Button, Stack, Typography, TextField, useTheme, useMediaQuery, MenuItem, Dialog } from "@mui/material";
import { useState, useContext, useEffect, useMemo } from "react";
import { Scanner } from '@yudiel/react-qr-scanner';
import { Context } from "../App";
import { API } from "../conf";
import Header from "./Header";
import AutoSearch from "./auto-complet-search";

export default function QRScan() {
    const {updateConnect} = useContext(Context)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [load, setLoad] = useState(true)
    const [scan, setScan] = useState(false)
    const [delegue, setDelegue] = useState()
    const [delegues, setDelegues]= useState([])
    const [sessions, setSessions] = useState([])
    const [sessionId, setSessionId] = useState('')
    const [msg, setMsg] = useState('')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')

    const session = useMemo(()=> sessions.find(s=>s._id===sessionId), [sessionId, sessions])

    function handleScan(data){
        setLoad(true); setMsg('')
        const result = data[0]?.rawValue; 
        if (Boolean(result)) {
            registDelegue(result)
        } else {
            setLoad(false)   
        }
    }

    function registDelegue(dlg) {
        fetch(API.concat(`/Session/${sessionId}/register/${dlg}`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setDelegue(json)
                } else {
                    const text = await response.text()
                    setMsg(text); setDelegue()
                }
                setLoad(false)
            }
        })
    }

    function manageDialogue(status, action) {
        setOpen(status); setAction(action)
        if (!status) {
            setMsg(''); setDelegue();
        }
    }

    function handleSearch(){
        setLoad(true); setMsg(''); setScan(false); setDelegue()
        fetch(API.concat('/Delegue/all'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setDelegues(json); manageDialogue(true, 'search')
                }
                setLoad(false)
            }
        })
    }

    useEffect(()=>{
        fetch(API.concat(`/Session/by/${JSON.stringify({active: true})}`), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{  
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setSessions(json)
                    setLoad(false)
                }
            }
        })
    },[updateConnect])


    return(
        <div>
            <Header/>
            <Box display='flex' flexDirection='column' sx={{flex:1, marginY:'20px', marginX:3}}>
                <Typography variant={isMobile?"h4":"h3"} align="center">AGO {new Date().getFullYear()}</Typography>
                {session&&<Button variant="contained" sx={{alignSelf:'flex-end', marginTop:2}} onClick={handleSearch}>Recherche Manuelle</Button>}
                <Typography variant="h5" align="center">Scanner</Typography>
                <TextField select fullWidth={isMobile} label="Session" sx={{minWidth:'200px'}} value={sessionId} 
                onChange={(event)=>setSessionId(old=>{if(old!==event.target.value){setScan(false); setDelegue(); setMsg('')} return event.target.value})}>
                    {sessions.map((item, index)=><MenuItem key={index} value={item._id}>{item.label+(item.isRepas?'(repas)':'')}</MenuItem>)}
                </TextField>
                {!scan&&session&&<Button variant="contained" sx={{alignSelf:'center', marginTop:'100px'}} onClick={()=> {setScan(true); setMsg('');setDelegue()}}>Scanner</Button>}
                {scan&&<Button variant="contained" sx={{alignSelf:'center', marginTop:'30px', marginBottom:'20px'}} onClick={()=> {setScan(false);setDelegue();setMsg('')}}>Arrêter</Button>}
                {scan&&<Scanner styles={{container:{width:'300px', height:'300px', alignSelf:'center', marginBottom:'30px'}}} scanDelay={500} onScan={handleScan} />}
                {delegue&&<Typography variant="h5" fontWeight='bold' textTransform="capitalize" align="center">{delegue.nom?.toUpperCase()} {delegue.prenoms}</Typography>}
                {msg!==''&&<Typography variant="h6" align="center" color="error">{msg}</Typography>}
                {delegue&&session.isRepas&&msg===''&&<Typography variant="h6" align="center">Repas: {delegue.repas.find(rp=>rp.repas===session.label)?.count}</Typography>}
                <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
            </Box>
            <Dialog open={open} onClose={()=>manageDialogue(false, '')} maxWidth='md' fullWidth>
                {action==='search'&&<Box display='flex' flexDirection='column' sx={{padding:2}}>
                    <AutoSearch {...{data:delegues, style:{minWidth:'200px'}, filterKeys:['nom', 'prenoms'], getLabel:item=>item.nom+' '+item.prenoms, setSelected:setDelegue}}/>
                    <Button variant="contained" sx={{alignSelf:'center', marginTop:2}} onClick={()=>{manageDialogue(false, ''); registDelegue(delegue._id)}}>Valider</Button>
                </Box>}
            </Dialog>
        </div>
    )
}